import { createContext, useContext } from 'react';

const PendingReviewContext = createContext(false);

export const PendingReviewProvider = PendingReviewContext.Provider;
export const usePendingReviewBlocked = () => useContext(PendingReviewContext);
